<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>年列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="24">
        <!-- <el-col :span="18">
          <el-form
              :inline="true"
              :model="searchForm"
              :rules="searchRules"
              ref="searchForRef"
              label-width="80px"
              autocomplete="on"
            >
            <el-form-item label="用户名" size="small">
              <el-input v-model="searchForm.name" placeholder="请输入用户名" type="text" name="name"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile" size="small">
              <el-input v-model="searchForm.mobile" placeholder="请输入手机号码" type="text" name="mobile"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
          <el-col :span="1">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
          </el-col> -->
        <el-col :span="1">
          <el-button size="mini" type="primary" @click="addData">新增</el-button>
        </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table
        border
        :data="tableLoadData"
        style="width: 100%; margin-top:20px"
        row-key="id"
        stripe
        size="mini"


      >
        <el-table-column prop="name" label="名称" width="250"></el-table-column>

        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="warning " icon="el-icon-edit" size='mini' @click="handelEdit(scope.row)"></el-button>
            <el-button type="danger " icon="el-icon-delete" size='mini' @click="handelDel(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form size="mini" :model="addForm" :rules="rules" ref="form" label-width="80px">
<!--        <el-form-item label="字典分类">-->
<!--          <el-cascader-->
<!--            v-model="addForm.pid"-->
<!--            :props="{ value: 'id', label: 'name', checkStrictly: true }"-->
<!--            :options="options"-->
<!--            :show-all-levels="false"-->
<!--            @change="handleChange">-->
<!--          </el-cascader>-->
<!--        </el-form-item>-->
        <el-form-item label="名称" prop="name">
          <el-input v-model="addForm.name" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
<!--        <el-form-item label="编码">-->
<!--          <el-input v-model="addForm.code" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="排序" prop="sort">
          <el-input v-model="addForm.sort" type="text" name="sort"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import moment from 'moment'     //日期时间转换

  export default {
    name: "yearList",
    components: {

    },
    props: {},
    data() {
      return {
        // 搜索
        searchForm: {
          name: "",
          mobile: '',
          status: 0
        },
        searchRules: {
          name: [
            { required: true, message: "请输入管理员名称", trigger: "blur" }
          ],
        },

        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数
        baseUrl:this.$store.state.defineWebURL,
        id: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            {
              min: 1,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],
          mobile: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            {
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: "只能输入11位手机号码",
            },
          ],
          // email: [
          //   { required: true, message: "请输入邮箱", trigger: "blur" },
          //   {
          //     pattern: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
          //     message: "邮箱格式错误, 请重新输入",
          //   },
          // ],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          position: [
            { required: true, message: '请输入职位', trigger: 'blur' }
          ],
          role_id: [
            { required: true, message: '请选择角色', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择状态', trigger: 'change' }
          ],
          sex: [
            { required: true, message: '请选择性别', trigger: 'change' }
          ],
        },

        dialogFormVisible: false,
        title: '',
        form: {
          pid: '',
          name: '',
          mobile: '',
          contact_name: ''
        },
        addForm: {
          id:'',
          pid: '',
          name: '',
          code: '',
          sort: ''
        },
        disabled: false,

        // 所有权限的数据
        rightslist: [],
        // 树形控件的属性绑定对象
        treeProps: {
          label: 'name',
          children: 'children'
        },
        // 默认选中的节点Id值数组
        // 当前即将分配权限的角色id
        roleId: '',

        idsArr: [],


        options: []

      };
    },
    created() {
      this.DataList()

    },
    mounted() {

    },
    filters: {
      /**
       * @param {
       *
       * }
       */
      sexFilter(type) {
        if (type == 1) {
          return "男";
        } else if (type == 0) {
          return "女";
        }
      },
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    methods: {
      handleChange(value) {
        let lastElement = value[value.length-1];
        this.addForm.pid = lastElement
        console.log((lastElement));
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.findCarYearListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data

            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      dicData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findDicTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.title = '新增'
        this.addForm = {
          name: '',
        }
        this.addForm.id='';
        this.dialogFormVisible = true
      },
      handelEdit(index) {
        this.id = index.id
        this.title = '编辑'
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者

        this.addForm = JSON.parse(JSON.stringify(index))
        console.log(' this.addForm', this.addForm)
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
               // pid: this.addForm.pid,
                name: this.addForm.name,
               // code: this.addForm.code,
              //  sort: this.addForm.sort,
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.carYearSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.addForm.id,
               // pid: this.addForm.pid,
                name: this.addForm.name,
               // code: this.addForm.code,
               // sort: this.addForm.sort,
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.carYearSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该部门, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          this.$axios.carYearDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
      // searchSubmit() {
      //   const param = {
      //       user_name: this.user_name,
      //       mobile: this.searchForm.mobile,
      //       company_id:sessionStorage.getItem('company_id'),
      //       access_token:sessionStorage.getItem('token'),
      //       pageNum: this.currentPage,
      //       pageSize: this.pageSize
      //   }
      //   this.$refs.searchForRef.validate((valid) => {
      //     if (valid) {
      //       this.$axios.employeeList(param).then(res=>{
      //         if(res.code == 200){
      //           this.tableLoadData = res.data.data
      //           this.total = res.data.total
      //         }
      //       })
      //     }
      //   })
      // }
    },
  };
</script>
<style>

</style>
